import React, { useState } from "react";
import CloseDetailPage from "../../../components/CloseComponent/CloseDetailPage";
import { LANGUAGES } from "../../../i18n/config";
import i18next from "i18next";
import { AiFillCheckCircle } from "react-icons/ai";
import Cookies from "js-cookie";
import { useDispatch } from "react-redux";
import { closeLanguagePop } from "../../../redux/action/member/memberAction";
import { useTranslation } from "react-i18next";
import { HiChevronLeft } from "react-icons/hi";
import CommonOpacityBackground from "../../../components/Common/commonOpacityBackground";
import { Flag } from "semantic-ui-react";

const LanguagePage = () => {
  const { t } = useTranslation();
  const i18n_common = (key) => t(`common.${key}`);

  const [lang, setLang] = useState(i18next.language);

  const dispatch = useDispatch();
  return (
    <CommonOpacityBackground
      customFunction={() => {
        dispatch(closeLanguagePop());
      }}
      className="!items-center"
    >
      <div
        onClick={(event) => {
          event.stopPropagation();
        }}
        className="w-[375px] min-h-[600px] bg-transaction-card dark:bg-base-light-dark rounded-[10px]"
      >
        <CloseDetailPage
          title={i18n_common("language")}
          hasPrev={
            <HiChevronLeft
              onClick={() => {
                dispatch(closeLanguagePop());
              }}
              className="cursor-pointer"
            />
          }
          customClose={<p></p>}
        />
        <section className="flex flex-col gap-[5px] rounded-[5px] p-[8px]">
          {LANGUAGES.map((item, index) => {
            return (
              <div
                onClick={(event) => {
                  event.stopPropagation();
                  setLang(item.language);
                  i18next.changeLanguage(item.language);
                  Cookies.set("language", item.language);
                }}
                className={`${
                  i18next.language === item.language
                    ? "bg-hover-transaction-card dark:bg-base-dark"
                    : "bg-transaction-card dark:bg-base-light-dark"
                } hover:bg-hover-transaction-card cursor-pointer rounded-[5px] p-[10px] flex items-center justify-between`}
              >
                <div className="flex items-center gap-[5px]">
                  <Flag
                    name={item.semantic_flag}
                    className="!w-[20px]"
                    height="15"
                  />
                  <span
                    className={`${
                      lang === item.language
                        ? "text-light-white"
                        : "text-light-text"
                    } font-medium`}
                  >
                    {item.text}
                  </span>
                </div>
                {i18next.language === item.language && (
                  <AiFillCheckCircle className="text-light-white text-2xl" />
                )}
              </div>
              // <Dropdown.Item
              //   key={index}
              //   onClick={(event) => {
              //     event.stopPropagation();
              //     i18n.changeLanguage(item.language);
              //   }}
              //   className="!flex items-center"
              // >
              //   <Flag code={item.flag} className="!w-[20px]" height="10" />
              //   <p>{item.text}</p>
              // </Dropdown.Item>
            );
          })}
        </section>
      </div>
    </CommonOpacityBackground>
  );
};

export default LanguagePage;
